"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useContainerRectangle = void 0;
var react_1 = require("react");
var types_1 = require("./types");
exports.useContainerRectangle = function (props) {
    var prevClientRect = react_1.useRef(null);
    var nextClientRect = react_1.useRef(null);
    var transitionState = props.transitionState, element = props.element, onFinish = props.onFinish;
    if (element && transitionState === types_1.TransitionState.Exit) {
        prevClientRect.current = element.getBoundingClientRect();
    }
    react_1.useLayoutEffect(function () {
        if (element && transitionState === types_1.TransitionState.ContainerRect) {
            nextClientRect.current = element.getBoundingClientRect();
            onFinish();
        }
    }, [transitionState]);
    return {
        prevClientRect: prevClientRect.current,
        nextClientRect: nextClientRect.current,
    };
};
